import { ChannelAppTabAction } from '../../services';
import { layoutPath } from './layoutPath';

interface GetAppTabHrefByActionTypeArgs {
  actionType: ChannelAppTabAction;
  storyId?: number;
}

export const getAppTabHrefByActionType = ({
  actionType,
  storyId,
}: GetAppTabHrefByActionTypeArgs) => {
  switch (actionType) {
    case ChannelAppTabAction.STORIES:
      return layoutPath('/storyTab1');
    case ChannelAppTabAction.STORIES2:
      return layoutPath('/storyTab2');
    case ChannelAppTabAction.STORIES3:
      return layoutPath('/storyTab3');
    case ChannelAppTabAction.STORIES4:
      return layoutPath('/storyTab4');
    case ChannelAppTabAction.STORIES5:
      return layoutPath('/storyTab5');
    case ChannelAppTabAction.PROFILE:
      return layoutPath('/profile');
    case ChannelAppTabAction.PINNED_STORY:
      return storyId
        ? layoutPath(`/pinnedStoryTab/${storyId}/items`)
        : layoutPath('/pinnedStoryTab');
    case ChannelAppTabAction.CHATS:
      return layoutPath('/chats');
    case ChannelAppTabAction.USER_DIRECTORY:
      return '/userDirectory';
    default:
      return '/';
  }
};
